import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectIssueNavigatorRoute: InvariantJiraRoute = {
	name: 'issue-navigator',
	path: '/projects/:projectKey/issues/:issueKey?',
};
